import { css, Theme } from '@emotion/react'
import { alpha, buttonClasses } from '@mui/material'

export const modalContainer = (theme: Theme) => css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${theme.backgrounds.backgroundFour};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  box-shadow: ${theme.boxShadows.small};
  border-radius: 24px;
  padding: 21px;
  width: 461px;
  box-sizing: border-box;
  max-height: 90vh;
  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }

  ${theme.breakpoints.down(620)} {
    width: 95%;
  }
`

export const form = css`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const title = (theme: Theme) => css`
  margin-bottom: ${theme.spacing(1)};

  text-align: center;
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;
  color: ${theme.colors.typographyTwo};
`

export const actions = css`
  display: flex;
  gap: 10px;
`

export const actionButton = (theme: Theme) => css`
  flex: 1;

  &.${buttonClasses.disabled} {
    svg {
      width: 22px;
      height: 22px;

      path {
        stroke: ${alpha(theme.colors.red, 0.5)};
      }
    }
  }
`
